import { render, staticRenderFns } from "./outbound-tour.vue?vue&type=template&id=5a7a877a&scoped=true"
import script from "./outbound-tour.vue?vue&type=script&lang=js"
export * from "./outbound-tour.vue?vue&type=script&lang=js"
import style0 from "./outbound-tour.vue?vue&type=style&index=0&id=5a7a877a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7a877a",
  null
  
)

export default component.exports